import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Showcase } from "@/components/Showcase";
import { SouvlakiFeature } from "@/components/SouvlakiFeature";
import { MenuSection } from "@/components/MenuSection";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.09,
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    lenis.on("scroll", () => {});

    // anchor links → lenis
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          const target = el.getBoundingClientRect().top + window.scrollY - 96;
          lenis.scrollTo(target, { force: true });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Showcase />
        <SouvlakiFeature />
        <MenuSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
